"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
require("./DataTable.css");
var UIProps_1 = require("../../UIProps");
var Button_1 = require("../../button/Button");
var Icon_1 = require("../../icon/Icon");
var lodash_1 = require("lodash");
var string_1 = require("../../../utils/string");
var types_1 = require("../../types");
var DataTableCollapse_1 = require("../DataTableCollapse/DataTableCollapse");
var gsap_1 = require("gsap/dist/gsap");
var Draggable_1 = require("gsap/dist/Draggable");
var ScrollToPlugin_1 = require("gsap/dist/ScrollToPlugin");
var native_1 = require("../../../utils/native");
gsap_1.gsap.registerPlugin(Draggable_1.Draggable, ScrollToPlugin_1.ScrollToPlugin);
var DataTableTheme;
(function (DataTableTheme) {
    DataTableTheme["collapse"] = "collapse";
})(DataTableTheme = exports.DataTableTheme || (exports.DataTableTheme = {}));
var DataTableComp = function (_a) {
    var _b = _a.showHeader, showHeader = _b === void 0 ? true : _b, _c = _a.collapseLevel, collapseLevel = _c === void 0 ? 0 : _c, props = __rest(_a, ["showHeader", "collapseLevel"]);
    var el = react_1.useRef(null);
    var draggable = react_1.useRef();
    var isMobileDevice = react_1.useRef(!!native_1.isMobile.any());
    var _d = __read(react_1.useState([[]]), 2), cells = _d[0], setCells = _d[1];
    var _e = __read(react_1.useState({
        tableKey: props.startSort ? props.startSort.tableKey : '',
        type: props.startSort ? props.startSort.type : undefined,
    }), 2), sort = _e[0], setSort = _e[1];
    react_1.useEffect(function () {
        if (!isMobileDevice.current && collapseLevel === 0) {
            //allow draggable scrolling anywhere on table when table has scrollbar on desktop
            draggable.current = new Draggable_1.Draggable(el.current, {
                type: 'scroll',
            });
        }
        return function () {
            if (draggable.current)
                draggable.current.kill();
        };
    }, []);
    react_1.useEffect(function () {
        if (sort.tableKey !== '' && sort.type !== undefined) {
            setCells(sortTableCells(props.cells, sort));
        }
        else {
            setCells(props.cells || [[]]);
        }
    }, [props.cells, sort]);
    var getSortType = function (cellTableKey, sortable) {
        if (sortable &&
            sort.type !== undefined &&
            sort.tableKey !== '' &&
            sort.tableKey === cellTableKey) {
            if (sort.type === types_1.SortType.ASC) {
                return 'ascending';
            }
            else if (sort.type === types_1.SortType.DESC) {
                return 'descending';
            }
            else {
                return 'none';
            }
        }
        else {
            return undefined;
        }
    };
    //---- Render Methods ----//
    function renderTableHeader() {
        return (React.createElement("tr", { className: classnames_1.default('DataTable_headerRow', {
                'sr-only': !showHeader,
            }) }, props.headerCells.map(function (cell, colIndex) { return (React.createElement("th", { className: classnames_1.default('DataTable_col', cell.className), key: colIndex, scope: 'col', "aria-sort": getSortType(cell.tableKey, cell.sortable) }, cell.sortable ? (React.createElement(Button_1.Button, { className: classnames_1.default('DataTable_sortButton', {
                'DataTable_sortButton-active': cell.tableKey === sort.tableKey,
            }), "aria-label": (typeof cell.title === 'string' ? cell.title + ' ' : '') + "sort " + (getSortType(cell.tableKey, cell.sortable) || ''), 
            //aria-pressed={getSortType(cell.tableKey, cell.sortable) === 'ascending'}
            onClick: function (e) { return onSortClick(cell, e); } },
            cell.title,
            React.createElement(Icon_1.Icon, { type: Icon_1.IconType.sort }))) : (cell.title))); })));
    }
    function renderRow(sectionData, secIndex, rowData, rowIndex) {
        return (React.createElement("tr", { className: classnames_1.default('DataTable_row', "DataTable_row" + rowIndex, "DataTable_sec" + secIndex, {
                DataTable_sectionRow: rowIndex === 0,
                DataTable_sectionRowEnd: rowIndex === sectionData.length - 1,
                DataTableCollapse_row: collapseLevel > 0 && secIndex === 0 && rowIndex === 0,
            }), key: rowIndex }, props.headerCells.map(function (headerCell, colIndex) {
            var isCollapseColumn = collapseLevel > 0 &&
                secIndex === 0 &&
                rowIndex === 0 &&
                colIndex === 0;
            return (React.createElement("td", { className: classnames_1.default('DataTable_col', "DataTable_col" + colIndex, headerCell.className, {
                    DataTableCollapse_firstCol: isCollapseColumn,
                }), key: colIndex, onClick: isCollapseColumn ? props._onCollapseClick : undefined },
                headerCell.changeCell
                    ? headerCell.changeCell(rowData[headerCell.tableKey], rowData)
                    : headerCell.formattedValue
                        ? headerCell.formattedValue(rowData[headerCell.tableKey], rowData)
                        : props.cellNullPlaceholder &&
                            string_1.isNull(rowData[headerCell.tableKey])
                            ? props.cellNullPlaceholder
                            : typeof rowData[headerCell.tableKey] === 'boolean'
                                ? rowData[headerCell.tableKey].toString()
                                : rowData[headerCell.tableKey],
                isCollapseColumn && (React.createElement(Icon_1.Icon, { className: 'DataTableCollapse_icon', type: Icon_1.IconType.chevronDown }))));
        })));
    }
    //---- Handlers ----//
    function onSortClick(cell, e) {
        if (cell.onExternalSort) {
            setSort({ tableKey: cell.tableKey, type: undefined });
            cell.onExternalSort(cell.tableKey);
            if (props.onSort)
                props.onSort(null, cell);
        }
        else {
            var sortType = sort.type !== types_1.SortType.ASC ? types_1.SortType.ASC : types_1.SortType.DESC;
            setSort({ tableKey: cell.tableKey, type: sortType });
            setCells(sortTableCells(cells, { tableKey: cell.tableKey, type: sortType }));
            if (cell.onSort)
                cell.onSort(sortType, cell.tableKey);
            if (props.onSort)
                props.onSort(sortType, cell);
        }
    }
    return (React.createElement("div", __assign({ ref: el, role: 'region', "aria-label": props.caption }, UIProps_1.setUIProps(props), { className: classnames_1.default('DataTable', "DataTable-level" + collapseLevel, props.theme ? "DataTable-" + props.theme : null, props.className) }),
        React.createElement("table", { className: 'DataTable_table' },
            props.caption && (React.createElement("caption", { className: 'DataTable_caption' }, props.caption)),
            React.createElement("thead", null, renderTableHeader()),
            cells.length > 0 && (React.createElement("tbody", null, cells.map(function (secData, secIndex) { return (React.createElement(React.Fragment, { key: secIndex },
                secData.map(function (rowData, rowIndex) {
                    var dataTableCollapse = rowData.dataTableCollapse, firstRowColumnData = __rest(rowData, ["dataTableCollapse"]);
                    var dataHasCollapse = dataTableCollapse &&
                        Array.isArray(dataTableCollapse) &&
                        dataTableCollapse.length > 0;
                    if (dataHasCollapse) {
                        var collapseData = [
                            __spread([
                                __assign({}, firstRowColumnData)
                            ], dataTableCollapse),
                        ];
                        return (React.createElement("tr", { key: rowIndex },
                            React.createElement("td", { className: 'DataTableCollapse_tdWrapper', colSpan: props.headerCells.length },
                                React.createElement(DataTableCollapse_1.DataTableCollapse, { caption: undefined, className: "DataTableCollapse_level" + (collapseLevel + 1), headerCells: props.headerCells, cells: collapseData, collapseLevel: collapseLevel + 1, cellNullPlaceholder: props.cellNullPlaceholder, expanded: props.expandAll, onToggle: function (expanded, e) {
                                        if (props.onAnyCollapseClick)
                                            props.onAnyCollapseClick(expanded, rowData, e);
                                    }, onAnyCollapseClick: function (expanded, collapseRowData, e) {
                                        if (props.onAnyCollapseClick)
                                            props.onAnyCollapseClick(expanded, collapseRowData, e);
                                    } }))));
                    }
                    else {
                        return renderRow(secData, secIndex, rowData, rowIndex);
                    }
                }),
                cells.length > 0 &&
                    secIndex !== cells.length - 1 &&
                    !collapseLevel && (React.createElement("tr", { className: 'DataTable_sectionSpacer' }, props.headerCells.map(function (headerCell, colIndex) { return (React.createElement("td", { key: colIndex })); }))))); }))))));
};
exports.DataTable = React.memo(DataTableComp);
function sortTableCells(cells, _a) {
    var tableKey = _a.tableKey, type = _a.type;
    if (cells && cells.length === 1 && cells[0]) {
        // eslint-disable-next-line prefer-const
        var _b = __read(cells), sortedCells = _b[0], otherCells = _b.slice(1);
        var sortType = type || types_1.SortType.ASC;
        sortedCells =
            cells[0].length > 1
                ? lodash_1.orderBy(sortedCells, [tableKey], [sortType])
                : sortedCells;
        return __spread([sortedCells], otherCells);
    }
    return cells || [[]];
}
exports.sortTableCells = sortTableCells;
var searchMatchesRow = function (row, searchVal, tableKeys) {
    var hasSearchVal = false;
    for (var key in row) {
        var prop = row[key];
        if (prop !== null) {
            var hasKey = tableKeys ? tableKeys.indexOf(key) !== -1 : true;
            if (hasKey) {
                var holdingProp = String(prop).toLowerCase();
                if (holdingProp.indexOf(searchVal) !== -1) {
                    hasSearchVal = true;
                }
            }
        }
    }
    return hasSearchVal;
};
var searchByLevel = function (sectionData, searchVal, tableKeys) {
    var levelData = [];
    sectionData.forEach(function (row) {
        var rowHasCollapse = row.dataTableCollapse &&
            Array.isArray(row.dataTableCollapse) &&
            row.dataTableCollapse.length > 0;
        if (rowHasCollapse) {
            var curLevelData = searchByLevel(row.dataTableCollapse, searchVal, tableKeys);
            if (curLevelData.length > 0) {
                levelData = __spread(levelData, [__assign(__assign({}, row), { dataTableCollapse: curLevelData })]);
            }
            else {
                var dataTableCollapse = row.dataTableCollapse, rowWithoutCollapse = __rest(row, ["dataTableCollapse"]);
                if (searchMatchesRow(rowWithoutCollapse, searchVal, tableKeys)) {
                    levelData = __spread(levelData, [rowWithoutCollapse]);
                }
            }
        }
        else {
            if (searchMatchesRow(row, searchVal, tableKeys)) {
                levelData = __spread(levelData, [row]);
            }
        }
    });
    return levelData;
};
function filterTable(tableData, query, tableKeys) {
    var searchVal = query.toLowerCase();
    return tableData.map(function (sectionData) {
        return searchByLevel(sectionData, searchVal, tableKeys);
    });
}
exports.filterTable = filterTable;
// return filtered dataTable
// export function filterTable(tableData: DataTableCell[][], query: string, tableKeys?: string[]): DataTableCell[][] {
//   const searchVal = query.toLowerCase();
//
//   return tableData.map((sectionData: DataTableCell[]) => (
//     sectionData.filter((row: DataTableCell) => {
//       let hasSearchVal = false;
//
//       forIn(row, (prop, key) => {
//         if (prop !== null) {
//           const hasKey = tableKeys ? tableKeys.indexOf(key) !== -1 : true;
//
//           if (hasKey) {
//             const holdingProp = String(prop).toLowerCase();
//
//             if (holdingProp.indexOf(searchVal) !== -1) {
//               hasSearchVal = true;
//             }
//           }
//         }
//       });
//
//       return hasSearchVal;
//     })
//   ))
// }
function _parseToCSV(headerCells, tableData, indentationPattern //optional parameter
) {
    if (indentationPattern === void 0) { indentationPattern = []; }
    var wrapWithQuotes = function (str) { return '"' + lodash_1.replace(str, /"/g, '""') + '"'; };
    var csvContent = [];
    var tableHeaders = headerCells.filter(function (headerCell) { return headerCell.tableKey; });
    var headerLabels = tableHeaders.map(function (headerCell) {
        var _a;
        var result = '';
        if (headerCell.title) {
            if (typeof headerCell.title === 'string') {
                //wrap texts in double quotes to allow commas (,) in texts &
                //replace double quotes with 2 double quotes to retain it in output
                result = wrapWithQuotes(headerCell.title);
            }
            else if (typeof headerCell.title === 'object') {
                var title = headerCell.title;
                var children = title.props.children;
                var hasInnerText = typeof children === 'string';
                var hasSROnly = (_a = title.props.className) === null || _a === void 0 ? void 0 : _a.includes('sr-only');
                if (!hasSROnly) {
                    result = hasInnerText
                        ? wrapWithQuotes(children)
                        : wrapWithQuotes(headerCell.tableKey);
                }
            }
        }
        return result;
    });
    if (headerLabels.some(function (label) { return typeof label === 'string' && label.length > 0; })) {
        csvContent.push(headerLabels.join(',') + '\n');
    }
    var getSectionLevelCsv = function (section, level) {
        section.forEach(function (row) {
            var csvRow = tableHeaders
                .map(function (headerCell, index) {
                var cell = row[headerCell.tableKey];
                if (headerCell.formattedValue)
                    cell = headerCell.formattedValue(cell, row);
                else if (string_1.isNull(cell))
                    return '';
                //if first column
                if (index === 0) {
                    //if developer has passed indentationPattern array
                    if (indentationPattern.length > level) {
                        return (
                        //wrap texts in double quotes to allow commas (,) in texts &
                        //replace double quotes with 2 double quotes to retain it in output
                        '"' +
                            String(indentationPattern[level]).concat(lodash_1.replace(String(cell), /"/g, '""')) +
                            '"');
                    }
                    else {
                        //if developer has not passed indentationPattern array
                        //then add 2 spaces for each level as indentation
                        var indentation = '';
                        for (var i = 0; i < level; i++)
                            indentation = indentation.concat('  ');
                        return (
                        //wrap texts in double quotes to allow commas (,) in texts
                        //replace double quotes with 2 double quotes to retain it in output
                        '"' +
                            indentation.concat(lodash_1.replace(String(cell), /"/g, '""')) +
                            '"');
                    }
                }
                else {
                    //if any other column then no indentation is required
                    return '"' + lodash_1.replace(String(cell), /"/g, '""') + '"';
                }
            })
                .join(',');
            csvContent.push(csvRow + '\n');
            if (row.dataTableCollapse &&
                row.dataTableCollapse.length > 0) {
                getSectionLevelCsv(row.dataTableCollapse, level + 1);
            }
        });
    };
    tableData.forEach(function (section) {
        getSectionLevelCsv(section, 0);
    });
    return csvContent.join('');
}
function parseToCSV(headerCells, tableData, indentationPattern //optional parameter
) {
    if (indentationPattern === void 0) { indentationPattern = []; }
    // Lead with Byte Order Mark (BOM) to ensure Excel reads special characters with UTF-8 encoding.
    // https://stackoverflow.com/questions/42462764/javascript-export-csv-encoding-utf-8-issue/42466254
    var universalBOM = '\uFEFF';
    return universalBOM + _parseToCSV(headerCells, tableData, indentationPattern);
}
exports.parseToCSV = parseToCSV;
function parseMultipleTablesToCSV(csvTableData, rowDelimiter) {
    var csvData = csvTableData.map(function (table) {
        return parseToCSV(table.header, table.body);
    });
    var universalBOM = '\uFEFF';
    return universalBOM + csvData.join(rowDelimiter + '\n');
}
exports.parseMultipleTablesToCSV = parseMultipleTablesToCSV;
